/** The 50 most famous European monuments — the roadmap for the icon set.
 *
 * `drawn: true` = a vector exists in icons.tsx and is registered. Batches
 * flip these to true as the set is produced. Tile art only ever picks
 * from the drawn set (registry.DRAWN_MONUMENT_KEYS).
 */
export interface MonumentSpec {
  key: string;
  name: string;
  city: string;
  country: string; // ISO-ish label
  drawn: boolean;
}

export const MONUMENTS: MonumentSpec[] = [
  // --- Germany ---
  { key: "brandenburger-tor", name: "Brandenburger Tor", city: "Berlin", country: "DE", drawn: true },
  { key: "koelner-dom", name: "Kölner Dom", city: "Köln", country: "DE", drawn: true },
  { key: "neuschwanstein", name: "Schloss Neuschwanstein", city: "Schwangau", country: "DE", drawn: true },
  { key: "reichstag", name: "Reichstag", city: "Berlin", country: "DE", drawn: true },
  { key: "frauenkirche-dresden", name: "Frauenkirche", city: "Dresden", country: "DE", drawn: true },
  // --- France ---
  { key: "eiffel-tower", name: "Eiffelturm", city: "Paris", country: "FR", drawn: true },
  { key: "arc-de-triomphe", name: "Arc de Triomphe", city: "Paris", country: "FR", drawn: true },
  { key: "notre-dame", name: "Notre-Dame", city: "Paris", country: "FR", drawn: true },
  { key: "sacre-coeur", name: "Sacré-Cœur", city: "Paris", country: "FR", drawn: true },
  { key: "mont-saint-michel", name: "Mont-Saint-Michel", city: "Normandie", country: "FR", drawn: true },
  // --- Italy ---
  { key: "colosseum", name: "Kolosseum", city: "Rom", country: "IT", drawn: true },
  { key: "leaning-tower-pisa", name: "Schiefer Turm von Pisa", city: "Pisa", country: "IT", drawn: true },
  { key: "st-peters", name: "Petersdom", city: "Vatikan", country: "VA", drawn: true },
  { key: "st-marks", name: "Markusdom", city: "Venedig", country: "IT", drawn: true },
  { key: "trevi-fountain", name: "Trevi-Brunnen", city: "Rom", country: "IT", drawn: true },
  { key: "duomo-milano", name: "Mailänder Dom", city: "Mailand", country: "IT", drawn: true },
  // --- United Kingdom / Ireland ---
  { key: "big-ben", name: "Big Ben", city: "London", country: "UK", drawn: true },
  { key: "tower-bridge", name: "Tower Bridge", city: "London", country: "UK", drawn: true },
  { key: "london-eye", name: "London Eye", city: "London", country: "UK", drawn: true },
  { key: "stonehenge", name: "Stonehenge", city: "Wiltshire", country: "UK", drawn: true },
  { key: "edinburgh-castle", name: "Edinburgh Castle", city: "Edinburgh", country: "UK", drawn: true },
  { key: "cliffs-of-moher", name: "Cliffs of Moher", city: "Clare", country: "IE", drawn: true },
  // --- Spain / Portugal ---
  { key: "sagrada-familia", name: "Sagrada Família", city: "Barcelona", country: "ES", drawn: true },
  { key: "alhambra", name: "Alhambra", city: "Granada", country: "ES", drawn: true },
  { key: "guggenheim-bilbao", name: "Guggenheim", city: "Bilbao", country: "ES", drawn: true },
  { key: "belem-tower", name: "Torre de Belém", city: "Lissabon", country: "PT", drawn: true },
  { key: "clerigos-tower", name: "Torre dos Clérigos", city: "Porto", country: "PT", drawn: true },
  // --- Benelux ---
  { key: "atomium", name: "Atomium", city: "Brüssel", country: "BE", drawn: true },
  { key: "grand-place", name: "Grand-Place", city: "Brüssel", country: "BE", drawn: true },
  { key: "windmills-kinderdijk", name: "Windmühlen", city: "Kinderdijk", country: "NL", drawn: true },
  { key: "rijksmuseum", name: "Rijksmuseum", city: "Amsterdam", country: "NL", drawn: true },
  // --- Central Europe ---
  { key: "charles-bridge", name: "Karlsbrücke", city: "Prag", country: "CZ", drawn: true },
  { key: "prague-castle", name: "Prager Burg", city: "Prag", country: "CZ", drawn: true },
  { key: "astronomical-clock", name: "Astronomische Uhr", city: "Prag", country: "CZ", drawn: true },
  { key: "schonbrunn", name: "Schloss Schönbrunn", city: "Wien", country: "AT", drawn: true },
  { key: "stephansdom", name: "Stephansdom", city: "Wien", country: "AT", drawn: true },
  { key: "chapel-bridge", name: "Kapellbrücke", city: "Luzern", country: "CH", drawn: true },
  { key: "matterhorn", name: "Matterhorn", city: "Zermatt", country: "CH", drawn: true },
  // --- Poland / Hungary ---
  { key: "wawel-castle", name: "Wawel", city: "Krakau", country: "PL", drawn: true },
  { key: "warsaw-palace", name: "Kulturpalast", city: "Warschau", country: "PL", drawn: true },
  { key: "hungarian-parliament", name: "Parlament", city: "Budapest", country: "HU", drawn: true },
  { key: "fishermans-bastion", name: "Fischerbastei", city: "Budapest", country: "HU", drawn: true },
  // --- Greece / Turkey ---
  { key: "parthenon", name: "Parthenon", city: "Athen", country: "GR", drawn: true },
  { key: "meteora", name: "Meteora", city: "Thessalien", country: "GR", drawn: true },
  { key: "santorini", name: "Santorini", city: "Kykladen", country: "GR", drawn: true },
  { key: "hagia-sophia", name: "Hagia Sophia", city: "Istanbul", country: "TR", drawn: true },
  // --- Nordics / Baltics ---
  { key: "little-mermaid", name: "Kleine Meerjungfrau", city: "Kopenhagen", country: "DK", drawn: true },
  { key: "nyhavn", name: "Nyhavn", city: "Kopenhagen", country: "DK", drawn: true },
  // --- Russia ---
  { key: "st-basils", name: "Basilius-Kathedrale", city: "Moskau", country: "RU", drawn: true },
  { key: "hermitage", name: "Eremitage", city: "St. Petersburg", country: "RU", drawn: true },
];
